import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import "./ModalUser.css"
import CloseIcon from '@mui/icons-material/Close';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useNavigate } from 'react-router';
import { Button } from '@mui/material';
import EditModal from '../EditModal/EditModal';
import axiosApiInstance from '../axios';
import Avatar from '@mui/material/Avatar';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";


function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
      width : 55,
      height : 55,
    },
    children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
  };
}


const ModalUser = ({ isOpen,userId, onClosing }) => {
  const { instance } = useMsal();

  const [user, setUser] = useState([]);
  const [userProfile, setUserProfile] = useState([]);
  const [edit, setEdit] = useState(false);
  
  const navigate = useNavigate();

  const config = { responseType: 'blob' };

  useEffect(() => {
    // add axios here
    axiosApiInstance.get(`user/downloadProfile/${userId}`,config)
      .then(res => {
        const reader = new FileReader();
    reader.readAsDataURL(res.data);
    reader.onloadend = () => {
      const base64data = reader.result;
      setUserProfile(base64data);
    };
      })
      .catch(err => console.log(err))
  }, [edit,user])

  useEffect(() => {
    // add axios here
    axiosApiInstance.get(`/user`)
      .then(res => setUser((res.data.data)))
      .catch(err => console.log(err))
  }, [])

  const handleLogout=(instance)=> {
    instance.logoutRedirect()
}

  const signOutLogic = () => {
    document.getElementById('root-portal').classList.add('logged-off');
    localStorage.removeItem("token");
    localStorage.removeItem("userRole");
    localStorage.removeItem("id");
    localStorage.removeItem("url")
    navigate("/");
    // window.location.reload();
  }


  if (!isOpen) return null

  const editModal = () => {
    setEdit(!edit)
  }



  return ReactDOM.createPortal(
    <div className="modal-container">
      <div className="modal-top">
        <span className="profile-span">Profile</span>
        <p onClick={onClosing} ><CloseIcon /></p>
      </div>
      <div className="class-padding">
        <div className="modal-content">
          {edit ? <EditModal user={user} onProfileEdit={editModal} userProfile={userProfile} /> : <>
            {/* <img src={userProfile } placeholder="Sample Image" className="account-icon" /> */}
            <Avatar {...stringAvatar(user.fullName)}
        src={userProfile}
        />
            <Button className='btn-modal' style={{
              backgroundColor: "#0A387D"
            }} variant="contained" onClick={editModal}>Edit</Button>
          </>}
        </div>
        <div className="content-right">
          <span>{user.fullName}</span>
          <p>{user.department}</p>
          <p>{user.email}</p>
          <p>{user.phoneNumber}</p>
        </div>
      </div>
      <div  className='modal-signout-button-container'>
        <span  onClick={signOutLogic}>
        <button className="out-sign" variant="contained" onClick={() => handleLogout(instance)}>Sign Out</button>
        </span>
      </div>

    </div>,
    document.getElementById('root-portal')
  )
};

export default ModalUser;
